import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import * as moment from 'moment';

@Component({
  selector: 'app-employee-shift-mapping',
  templateUrl: './employee-shift-mapping.component.html',
  styleUrls: ['./employee-shift-mapping.component.css']
})
export class EmployeeShiftMappingComponent implements OnInit {
  ListDepartment = [];
  DesignationList = [];
  EmployeeList = [];
  ShiftList = [];
  EmployeeCategoryList = [];

  constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  EmployeeShiftMappingModel = {
    StaffShiftMapingID: 0,
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
    ShiftID: 0,
    StaffID:0,
    PrimaryDepartmentID: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity: '',
  }

  Clear() {
    this.EmployeeShiftMappingModel.StaffShiftMapingID = 0;
    this.EmployeeShiftMappingModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
    this.EmployeeShiftMappingModel.ToDate = moment(new Date()).format('DD-MMM-YYYY');
    this.EmployeeShiftMappingModel.ShiftID = 0;
    this.EmployeeList = [];
    this.Submitted = false;
    this.EmployeeShiftMappingModel.EmployeeCategoryID = 0;
    this.EmployeeShiftMappingModel.PrimaryDepartmentID = 0;
    this.EmployeeShiftMappingModel.DesignationID = 0;
    this.EmployeeShiftMappingModel.StaffID=0;
    this.EmployeeShiftMappingModel.StaffIdentity = '';

  }

  SearchModel = {
    FromDate: '',
    ToDate: '',
    ShiftID: 0,
    PrimaryDepartmentID: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity: '',
  }

  ClearSearch() {
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
    this.SearchModel.EmployeeCategoryID = 0;
    this.SearchModel.PrimaryDepartmentID = 0;
    this.SearchModel.DesignationID = 0;
    this.SearchModel.StaffIdentity = '';
    this.StaffShiftMapList = [];

  }



  Validation() {
    return this.EmployeeShiftMappingModel.ShiftID == 0 || this.EmployeeShiftMappingModel.FromDate == '' || this.EmployeeShiftMappingModel.ToDate == '';
  }

  Submitted = false;
  SaveEmployeeShiftMapping() {
    this.Submitted = true;
    if (!this.Validation()) {
      this.spinnerService.show();
      this.payrollService.SaveEmployeeShiftMapping(JSON.stringify(this.EmployeeShiftMappingModel), JSON.stringify(this.EmployeeList)).subscribe((response: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.Submitted = false;
        this.GetAllStaffShiftMap();
        this.GetAllEmployeeShift();
      });
    }
  };

  GetAllEmployeeShift() {
    this.spinnerService.show();
    this.EmployeeShiftMappingModel.FromDate = this.EmployeeShiftMappingModel.FromDate != null && this.EmployeeShiftMappingModel.FromDate != '' ? moment(this.EmployeeShiftMappingModel.FromDate).format('DD-MMM-YYYY') : '';
    this.EmployeeShiftMappingModel.ToDate = this.EmployeeShiftMappingModel.ToDate != null && this.EmployeeShiftMappingModel.ToDate != '' ? moment(this.EmployeeShiftMappingModel.ToDate).format('DD-MMM-YYYY') : '';
    this.payrollService.GetAllEmployeeShift(JSON.stringify(this.EmployeeShiftMappingModel)).subscribe((data: any) => {
      this.EmployeeList = data.EmployeeList;
      // this.ShiftList = data.ShiftList;
      this.spinnerService.hide();


    });
  };

  StaffShiftMapList = [];
  GetAllStaffShiftMap() {
    this.spinnerService.show();
    this.SearchModel.FromDate = this.SearchModel.FromDate != null && this.SearchModel.FromDate != '' ? moment(this.SearchModel.FromDate).format('DD-MMM-YYYY') : '';
    this.SearchModel.ToDate = this.SearchModel.ToDate != null && this.SearchModel.ToDate != '' ? moment(this.SearchModel.ToDate).format('DD-MMM-YYYY') : '';
    this.payrollService.GetAllStaffShiftMap(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.StaffShiftMapList = data.StaffShiftMapList;
      this.spinnerService.hide();


    });
  };
  IsSelect = false;
  SelectAll() {
    if (this.IsSelect) {
      for (var i = 0; i < this.EmployeeList.length; i++) {
        this.EmployeeList[i].IsActive = true;
      }
    }
    if (this.IsSelect == false) {
      for (var i = 0; i < this.EmployeeList.length; i++) {
        this.EmployeeList[i].IsActive = false;
      }
    }
  }
  Count1 = 0;
  ChangeSelect(item) {
    this.Count1 = 0;
    for (var i = 0; i < this.EmployeeList.length; i++) {
      if (this.EmployeeList[i].IsActive) {
        this.Count1 = this.Count1 + 1

      }
    }
    if (this.Count1 == this.EmployeeList.length) {
      this.IsSelect = true;

    }
    else {
      this.IsSelect = false;
    }

  }

  Edit(item) {
    this.EmployeeShiftMappingModel.FromDate = moment(item.FromDate).format('DD-MMM-YYYY');
    this.EmployeeShiftMappingModel.ToDate = moment(item.ToDate).format('DD-MMM-YYYY');
    this.EmployeeShiftMappingModel.ShiftID = item.ShiftID;
    this.EmployeeShiftMappingModel.StaffID = item.StaffID;
    this.EmployeeShiftMappingModel.StaffShiftMapingID = item.StaffShiftMapingID;
  }


  ngOnInit() {
    this.GetAllEmployeeCategory();
    this.GetDepartment();
    this.GetAllShift();
    this.GetDesignation();

  }


  GetAllShift() {
    this.lookupservice.GetLookupsList('Shift', '').subscribe((data: any) => {
      this.ShiftList = data.LookupItems;

    });

  }

  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.ListDepartment = data.LookupItems;
    });

  }


  GetDesignation() {
    this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.DesignationList = data.LookupItems;
    });
  };

  GetAllEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });

  }

}
